import React, { useState } from "react";
import { FaFacebook ,FaInstagram, FaWhatsapp, FaLinkedinIn } from "react-icons/fa";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import emailjs from "emailjs-com";
import "../Contactus/Talk.css";

const Talk = () => {
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    zip: "",
    option: "",
    message: "",
  });

  const [formErrors, setFormErrors] = useState({ ...formData });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    validate(name, value);
  };

  const validate = (name, value) => {
    const errors = { ...formErrors };
    switch (name) {
      case "name":
        errors.name = /^[A-Za-z\s]+$/.test(value) ? "" : "Name should contain only alphabets.";
        break;
      case "email":
        errors.email = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) ? "" : "Invalid email address.";
        break;
      case "phone":
        errors.phone = /^\d{10}$/.test(value) ? "" : "Phone number should be 10 digits.";
        break;
      case "zip":
        errors.zip = /^\d{6}$/.test(value) ? "" : "Zip code should be 6 digits.";
        break;
      case "option":
        errors.option = value ? "" : "Please choose an option.";
        break;
      case "message":
        errors.message = value.length >= 15 ? "" : "Message should be at least 15 characters.";
        break;
      default:
        break;
    }
    setFormErrors(errors);
  };

 const handleSubmit = (e) => {
  e.preventDefault();
  setLoading(true);

  if (Object.values(formErrors).every((err) => err === "")) {
    emailjs
      .sendForm("service_c2jf13w", "template_c34kf4z", e.target, "UxPRjy8Ztmqt2j8Ls")
      .then(() => {
        Swal.fire(
          "Message Sent!",
          "Thank you for reaching out to <b>श्री Var Event & Conference</b>. We’ll get back to you shortly.",
          "success"
        );
        setFormData({ name: "", email: "", phone: "", zip: "", option: "", message: "" });
        setFormErrors({ name: "", email: "", phone: "", zip: "", option: "", message: "" });
      })
      .catch(() => {
        Swal.fire(
          "Oops!",
          "Please fill the form to send your message to <b>श्री Var Event & Conference</b>.",
          "error"
        );
      })
      .finally(() => setLoading(false));
  } else {
    Swal.fire(
      "Form Incomplete!",
      "Please correct the highlighted errors before submitting to <b>श्री Var Event & Conference</b>.",
      "error"
    );
    setLoading(false);
  }
};



  return (
    <div className="talk-container-tt">
      {/* Left Section */}
      <div className="left-section-tt">
        <h4 className="locations-heading-tt">OUR PRESENCE</h4>
        <h1 className="main-heading-tt">Let’s Plan Your Perfect Event</h1>
        <p className="description-tt">
          At श्री Var Event & Conference, we specialize in crafting memorable corporate and private experiences tailored to your vision. Reach out for personalized estimates and consultation.
        </p>
        <div className="social-icons-tt">
       
            <a href="https://www.instagram.com/shriivarevent/?igsh=bG9mb2o3b3gxZHh2#" target="_blank">
          <div className="icon-tt">
            <div className="icon-div-tt"><FaInstagram /></div>
           
          </div>
          </a>
           <a href="https://www.facebook.com/people/%E0%A4%B6%E0%A5%8D%E0%A4%B0%E0%A5%80-Var-Event-Conference/61576009690738/#" target="_blank">
          <div className="icon-tt">
            <div className="icon-div-tt"><FaFacebook  /></div>
           
          </div>
          </a>
          <a href="https://api.whatsapp.com/send/?phone=%2B919220347091&text&type=phone_number&app_absent=0" target="_blank">
          <div className="icon-tt">
            <div className="icon-div-tt"><FaWhatsapp /></div>
           
          </div>
          </a>
           <a href="https://www.linkedin.com/in/%E0%A4%B6%E0%A5%8D%E0%A4%B0%E0%A5%80-var-events-and-conferences-5a902a363/?originalSubdomain=in" target="_blank">
          <div className="icon-tt">
            <div className="icon-div-tt"><FaLinkedinIn /></div>
           
          </div>
          </a>
        </div>
      </div>

      {/* Right Section */}
      <div className="right-section-tt">
        <h2 className="form-heading-tt">Request an Event Estimate</h2>
        <form className="estimate-form-tt" onSubmit={handleSubmit}>
          <div className="form-row-tt">
            <div className="input-group">
              <input type="text" name="name" value={formData.name} onChange={handleInputChange} placeholder="Your name" />
              {formErrors.name && <span className="error">{formErrors.name}</span>}
            </div>
            <div className="input-group">
              <input type="email" name="email" value={formData.email} onChange={handleInputChange} placeholder="Email address" />
              {formErrors.email && <span className="error">{formErrors.email}</span>}
            </div>
          </div>

          <div className="form-row-tt">
            <div className="input-group">
              <input type="text" name="phone" value={formData.phone} onChange={handleInputChange} placeholder="Phone number" />
              {formErrors.phone && <span className="error">{formErrors.phone}</span>}
            </div>
            <div className="input-group">
              <input type="text" name="zip" value={formData.zip} onChange={handleInputChange} placeholder="Zip code" />
              {formErrors.zip && <span className="error">{formErrors.zip}</span>}
            </div>
          </div>

          <div className="input-group">
            <select name="option" value={formData.option} onChange={handleInputChange} className="dropdown-tt">
              <option value="">—Select Event Type—</option>
              <option value="Wedding Event">Wedding Event</option>
              <option value="Corporate Event">Corporate Event</option>
              <option value="Live Concert">Live Concert</option>
              <option value="Social Events">Social Event</option>
              <option value="Other">Other</option>
            </select>
            {formErrors.option && <span className="error">{formErrors.option}</span>}
          </div>

          <div className="input-group">
            <textarea name="message" value={formData.message} onChange={handleInputChange} placeholder="Your message here..."></textarea>
            {formErrors.message && <span className="error">{formErrors.message}</span>}
          </div>

         <button type="submit" className="submit-btn-tt" disabled={loading}>
  {loading ? "Sending..." : "Get Estimate"}
</button>

        </form>
      </div>
    </div>
  );
};

export default Talk;
